import { createReducer, AnyAction } from '@reduxjs/toolkit';
import { LoadingType as LoadingStoreState } from '../types/loading';
import { setIsLoading } from '../actions/app.actions';
import { injectProject } from '../actions/authenticationContext.actions';
import { setUserContext } from '../actions/userContext.actions';

export const initialState: LoadingStoreState = true;

interface Loading {
	[x: string]: (
		state: LoadingStoreState,
		action: AnyAction,
	) => LoadingStoreState | undefined;
}

const reducer: Loading = {
	[setIsLoading.toString()]: (state, action) => action.payload,
	[injectProject.toString()]: () => true,
	[setUserContext.toString()]: () => false,
};

export default createReducer(initialState, reducer);
